import React from 'react';
import { useSearchParams } from 'react-router-dom';
import './AdminDashboard.css';
import AdminProperties from './AdminProperties';
import AdminHero from './AdminHero';
import AdminBrochures from './AdminBrochures';
import { supabase } from '../../supabaseClient';

export default function AdminDashboard() {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = searchParams.get('tab') || 'hero';

  const tabs = [
    { id: 'hero', label: 'Hero Section' },
    { id: 'premium', label: 'Premium Properties' },
    { id: 'apartments', label: 'Apartments' },
    { id: 'villas', label: 'Villas' },
    { id: 'plots', label: 'Plots' },
    { id: 'commercial', label: 'Commercial' },
    { id: 'farmlands', label: 'Farm Lands' },
    { id: 'brochures', label: 'Brochures' }
  ];

  return (
    <div className="admin-dashboard-container">
      <aside className="admin-sidebar">
        <div className="admin-sidebar-header">
          <h2>Skyon Admin</h2>
        </div>
        <ul className="admin-nav-list">
          {tabs.map((tab) => (
            <li 
              key={tab.id} 
              className={`admin-nav-item ${activeTab === tab.id ? 'active' : ''}`}
              onClick={() => setSearchParams({ tab: tab.id })}
            >
              {tab.label}
            </li>
          ))}
        </ul>
        <div className="admin-sidebar-footer">
          <button className="admin-logout-btn" onClick={() => supabase.auth.signOut()}>Logout</button>
        </div>
      </aside>

      <main className="admin-main-content">
        <div className="admin-topbar">
          <h2>{tabs.find(t => t.id === activeTab)?.label} Management</h2>
        </div>
        <div className="admin-content-area">
          {activeTab === 'hero' && <AdminHero />}
          {activeTab === 'brochures' && <AdminBrochures />}
          {activeTab !== 'hero' && activeTab !== 'brochures' && <AdminProperties key={activeTab} category={activeTab} />}
        </div>
      </main>
    </div>
  );
}
